var _mask, _path, _path2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnotations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.9223C13.4183 14.9223 17 12.0296 17 8.46116C17 4.89276 13.4183 2 9 2C4.58172 2 1 4.89276 1 8.46116C1 10.4303 2.09068 12.1937 3.81075 13.3788L3.7743 17L7.66566 14.8329C8.09959 14.8917 8.54536 14.9223 9 14.9223Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.9223C13.4183 14.9223 17 12.0296 17 8.46116C17 4.89276 13.4183 2 9 2C4.58172 2 1 4.89276 1 8.46116C1 10.4303 2.09068 12.1937 3.81075 13.3788L3.7743 17L7.66566 14.8329C8.09959 14.8917 8.54536 14.9223 9 14.9223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81075 13.3788L4.8107 13.3889L4.81605 12.8571L4.37811 12.5553L3.81075 13.3788ZM3.7743 17L2.77435 16.9899L2.75702 18.7111L4.26085 17.8737L3.7743 17ZM7.66566 14.8329L7.80003 13.8419L7.47004 13.7972L7.17911 13.9592L7.66566 14.8329ZM16 8.46116C16 11.2883 13.0761 13.9223 9 13.9223V15.9223C13.7605 15.9223 18 12.7708 18 8.46116H16ZM9 3C13.0761 3 16 5.63399 16 8.46116H18C18 4.15154 13.7605 1 9 1V3ZM2 8.46116C2 5.63399 4.9239 3 9 3V1C4.23955 1 0 4.15154 0 8.46116H2ZM4.37811 12.5553C2.87102 11.517 2 10.0368 2 8.46116H0C0 10.8238 1.31035 12.8704 3.24339 14.2023L4.37811 12.5553ZM4.77425 17.0101L4.8107 13.3889L2.8108 13.3687L2.77435 16.9899L4.77425 17.0101ZM7.17911 13.9592L3.28775 16.1263L4.26085 17.8737L8.15221 15.7065L7.17911 13.9592ZM9 13.9223C8.59027 13.9223 8.18939 13.8947 7.80003 13.8419L7.53128 15.8238C8.00978 15.8887 8.50045 15.9223 9 15.9223V13.9223Z",
    fill: "#A4A4A4",
    mask: "url(#path-1-inside-1)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6.5,
    x2: 12,
    y2: 6.5,
    stroke: "#A4A4A4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8.5,
    x2: 12,
    y2: 8.5,
    stroke: "#A4A4A4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 10.5,
    x2: 12,
    y2: 10.5,
    stroke: "#A4A4A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotations);
export default __webpack_public_path__ + "static/media/annotations.8f4296df9eb7179eeb1d72886f2457db.svg";
export { ForwardRef as ReactComponent };